import { useState } from "react";

import Cookies from "shared/util/Cookies";
import loadjs from "shared/util/loadjs";

const SIFT_API_KEY = "24e1d3c3ce";
const SIFT_CLIENT_URL = "https://cdn.siftscience.com/s.js";

const initSiftScience = (userid) => {
	const sessionId = Cookies.getCookie("siftsession");

	window._sift = [
		...(window._sift || []),
		["_setAccount", SIFT_API_KEY],
		["_setUserId", userid],
		["_setSessionId", sessionId],
		["_trackPageview"],
	];
};

function useSiftScience({ userid }) {
	const [hasLoaded, setHasLoaded] = useState(false);

	if (!hasLoaded) {
		initSiftScience(userid);
		loadjs(SIFT_CLIENT_URL);
		setHasLoaded(true);
	}
}

export default useSiftScience;



// WEBPACK FOOTER //
// ./src/routers/shared/hooks/useSiftScience.js